type KeySelector<T> = keyof T | ((item: T) => PropertyKey);
type ValueSelector<T, V> = keyof T | ((item: T) => V);

// Перегрузки для точного вывода типов
export function arrayGroup<T>(
    array: readonly T[],
    keyField: KeySelector<T>
): Record<string, T[]>;

export function arrayGroup<T, K extends keyof T>(
    array: readonly T[],
    keyField: KeySelector<T>,
    valueField: K
): Record<string, T[K][]>;

export function arrayGroup<T, V>(
    array: readonly T[],
    keyField: KeySelector<T>,
    valueField: (item: T) => V
): Record<string, V[]>;

// Реализация
export function arrayGroup<T>(
    array: readonly T[],
    keyField: KeySelector<T>,
    valueField?: ValueSelector<T, any>
): Record<string, any> {
    return array.reduce((acc, item) => {
        // Извлекаем ключ
        const key = typeof keyField === 'function'
            ? keyField(item)
            : item[keyField];

        if (key == null) return acc;
        // Извлекаем значение
        let value: any;
        if (valueField === undefined) {
            value = item;
        } else if (typeof valueField === 'function') {
            value = valueField(item);
        } else {
            value = item[valueField];
        }

        if (Array.isArray(key)) {
            key.forEach((k) => {
                const keyStr = String(k);
                if (!acc[keyStr])
                    acc[keyStr] = []
                acc[keyStr].push(value)
            })
        } else {
            const keyStr = String(key);
            if (!acc[keyStr])
                acc[keyStr] = []
            acc[keyStr].push(value)
        }

        return acc;
    }, {} as Record<string, any>);
}
